<template>
  <div class="adjustment" @touch.prevent>
    <w-popup-show :state="state" @handleClose="closeWindow">
      <div slot="content" class="content-wrapper">
        <div class="header">
          <span class="iconfont iconx" @click="closeWindow"/>
          <span class="sure" @click="handleClick">确定</span>
        </div>
        <div class="exchange-content">
          <div class="exchange-container">
            <span @click="exchangeContent(1)" :class="{'active': contentIndex === 1}">样式</span>
            <span @click="exchangeContent(2)" :class="{'active': contentIndex === 2}">排版</span>
          </div>
        </div>
        <cube-scroll :data="[contentIndex]">
          <div class="content" v-show="contentIndex === 1">
            <div class="auto-one-page white-button flex-center" @click="onePage">
              <span class="iconfont iconfile-text"/>
              <span>{{pageText}}</span>
            </div>
            <div v-for="(item, index) in previewData.changeStyle" :key="index" class="module">
              <p class="title">{{item.title}}</p>
              <div class="container-wrapper">
                <cube-scroll :data="item.pickerData" direction="horizontal" class="horizontal-scroll-list-wrap"
                             :options="{startX: item.startX}">
                  <ul class="container list-wrapper" :class="{'color-container': item.type === 'theme_color'}">
                    <li v-for="val in item.pickerData" :key="val.value" @click="onChange(item, val.value)"
                        class="list-item" :style="item.type === 'theme_color' ? `background: ${val.value}` : ''"
                        :class="[item.type, item.value === val.value ? `${item.type}-active` : '', item.type === 'font' ? val.value : '']">
                      <span v-if="val.icon" class="iconfont" :class="val.icon"/>
                      <span
                          v-if="item.type !== 'theme_color'">{{item.type !== 'theme_color' ? val.name || val.value : ''}}</span>
                    </li>
                  </ul>
                </cube-scroll>
              </div>
            </div>
          </div>
          <div class="content" v-if="contentIndex === 2">
            <div v-for="item in previewData.typesetting" :key="item.type" class="module">
              <p v-if="item.title" class="title">{{item.title}}</p>
              <div class="container">
                <div v-for="val in item.pickerData" :key="val.value" class="setting-item">
                  <div class="radio-name">
                    <input type="radio" :name="item.type" class="name" :id="val.value" :disabled="item.type === 'format_priority'
                           && previewData.typesetting[3].value === 'one_line'
                           || item.type === 'punctuation_format' && previewData.typesetting[3].value === 'two_line'"
                           :checked="item.value === val.value" @change="onChange(item, val.value)"/>
                    <label :for="val.value">{{val.name}}</label>
                  </div>
                  <label class="desc" :for="val.value" v-if="val.desc">{{val.desc}}</label>
                </div>
              </div>
            </div>
          </div>
        </cube-scroll>
      </div>
    </w-popup-show>
  </div>
</template>

<script>
	import { mapState } from 'vuex'
	import WPopupShow from '@/components/global/w-popup-show'
	import previewData from '@/assets/json/cv'
	import { windowEventMixin } from '../../assets/js/mixin/global'
	import { componentsMixin } from '../../assets/js/mixin/components'


	export default {
		name: 'adjustment-preview',
		props: {
			state: {
				type: Boolean,
				default: false
			},
			pageText: {
				type: String,
				default: ''
			}
		},
		mixins: [ componentsMixin, windowEventMixin ],
		data () {
			return {
				previewData,
				contentIndex: 1
			}
		},
		mounted () {
			this._initValue()
		},
		computed: {
			...mapState('cv', [ 'cv' ])
		},
		watch: {
			cv () {
				this._initValue()
			},
			state (val) {
				if (val) {
					this._initValue()
				}
			}
		},
		components: { WPopupShow },
		methods: {
			onePage () {
				this.$emit('onePage', true)
				this.closeWindow()
			},
			exchangeContent (index) {
				this.contentIndex = index
			},
			closeWindow () {
				this.$emit('closeWindow')
			},
			async handleClick () {
				// 把vuex cv base中的值改变一下为了改变页面的布局
				this.previewData.changeStyle.forEach(item => {
					this.cv.base[item.type] = item.value
				})
				this.previewData.typesetting.forEach(item => {
					if (item.type === 'show_attr_name') {
						this.cv.profile.format_pref_show_attr_name = item.value
					} else {
						this.cv.base[item.type] = item.value
					}
				})
				let field = [
					'theme_color',
					'font',
					'font_size',
					'line_spacing',
					'page_margin',
					'head_format', 'time_format', 'format_priority', 'body_format', 'punctuation_format', 'show_attr_name' ]
				let payload = {}
				field.forEach(item => {
					payload[item] = this.cv.base[item]
				})
				payload.cv_token = this.$route.params.token
				payload.show_attr_name = this.cv.profile.format_pref_show_attr_name
				let res = await this.$api.cv.updateCvFormat(payload)
				if (res.status === 1) {
					this.$emit('change', 'change', res.data.cv.line_spacing)
				} else {
					this.$emit('出错了')
				}
			},
			onChange (item, value) {
				if (item.type === 'font') this.showToast('字体效果暂不支持预览<br/>请下载简历查看', 1500)
				item.value = value
				// if (item.type === 'body_format' && value === 'one_line') {
				//   this.previewData.typesetting[2].value = 'time'
				// } else if (item.type === 'body_format' && value === 'two_line') {
				//   this.previewData.typesetting[4].value = 'not_show_punctuation'
				// }
			},
			_initValue () {
				if (this.cv.base) {
					// 判断一下是英文简历还是中文简历选择font-family不同
					if (this.cv.base.lang === 'cn') {
						this.previewData.changeStyle[0] = this.previewData.fontFamilyCn
					} else if (this.cv.base.lang === 'en') {
						this.previewData.changeStyle[0] = this.previewData.fontFamilyEn
					}
					// 初始化高亮的数值
					this.previewData.changeStyle.forEach(item => {
						item.value = this.cv.base[item.type]
					})
					this.previewData.typesetting.forEach(item => {
						if (item.type === 'show_attr_name') {
							item.value = this.cv.profile.format_pref_show_attr_name
						} else {
							item.value = this.cv.base[item.type]
						}
					})
					// 如果格式为一行标题显示的话要把  时间/地点优先  设置为时间优先，因为一行标题不显示地点
					if (this.previewData.typesetting[3].value === 'one_line') this.previewData.typesetting[2].value = 'time'
					// 如果返回的数据line_height大于28的时候要把行高设置为28
					if (this.previewData.changeStyle[3].value > 28) this.previewData.changeStyle[3].value = 28
					// 初始化滚动的位置，把当前设置的值滚动到可视区之内
					this.previewData.changeStyle.forEach(item => {
						let index = item.pickerData.findIndex(val => item.value === val.value)
						if (index > 0 && item.width && (item.type === 'font_size' || item.type === 'line_spacing')) {
							item.startX = -(52 * index) + 52
						} else {
							item.startX = 0
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  $cnFontList: 'msyh', 'Source Han Serif SC', 'STKaitiSc';
  $cnFontCount: 1, 2, 3;
  $enFontList: 'Arial', 'Helvetica', 'Georgia', 'Times New Roman';
  $enFontCount: 4, 5, 6, 7;
  $cnFont: zip($cnFontList, $cnFontCount);
  $enFont: zip($enFontList, $enFontCount);
  // 选择字体的时候
  @each $a in $cnFont {
    .font-#{nth($a, 2)} {
      font-family: nth($a, 1);
    }
  }
  // 选择英文字体的时候
  @each $a in $enFont {
    .font-#{nth($a, 2)} {
      font-family: nth($a, 1), sans-serif;
    }
  }
  .adjustment {
    font-size: $font-size-medium;
    .content-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 26px 26px 0;
      width: 100vw;
      box-sizing: border-box;
      height: calc(var(--vh, 1vh) * 90);
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 26px;
        width: 100%;
        .iconfont {
          font-weight: bold;
          color: $color-light-gray;
          font-size: 22px;
        }
        .sure {
          color: $color-theme;
          font-size: $font-size-medium-x;
        }
      }
      .exchange-content {
        width: 100vw;
        font-size: $font-size-medium-x;
        color: $color-light-gray;
        border-bottom: 1px solid #e3e3e3;
        .exchange-container {
          padding: 0 26px;
          display: flex;
          span {
            margin-right: 42px;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .active {
            color: $color-title;
            &::after {
              content: '';
              display: inline-block;
              width: 18px;
              height: 2px;
              background-color: $color-theme;
              margin-top: 16px;
            }
          }
        }
      }
      .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 32px 26px;
        width: 100vw;
        box-sizing: border-box;
        .auto-one-page {
          margin-bottom: 26px;
          padding: 10px 20px;
          border-radius: 2px;
          .iconfont {
            font-weight: bold;
            margin-right: 8px;
          }
        }
        .module {
          margin-bottom: 36px;
          &:last-child {
            margin-bottom: 0;
          }
          .title {
            font-size: $font-size-medium;
            color: $color-title;
            margin-bottom: 16px;
          }
          .setting-item {
            display: flex;
            flex-direction: column;
            margin-bottom: 18px;
            &:last-child {
              margin-bottom: 0;
            }
            .radio-name {
              display: flex;
              align-items: center;
              label {
                padding-left: 16px;
              }
              .name {
                color: $color-dark-gray;
                font-size: $font-size-medium;
                -webkit-appearance: none;
                width: 14px;
                height: 14px;
                border: 1px solid $color-theme !important;
                border-radius: 50%;
                /*margin-right: 16px;*/
                padding: 0 !important;
                display: flex;
                justify-content: center;
                align-items: center;
                &:checked:after {
                  content: '';
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background-color: $color-theme;
                }
                &:disabled {
                  border-color: $color-light-gray !important;
                  &:after {
                    background-color: $color-light-gray;
                  }
                }
              }
              .name:disabled + label {
                color: $color-light-gray;
              }
            }
            .desc {
              color: $color-light-gray;
              padding-top: 10px;
              padding-left: 22px;
            }
          }
          .container-wrapper {
            width: calc(100vw - 52px);
            .color-container {
              width: calc(100vw - 52px);
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 10px 0;
            }
            .container {
              display: flex;
              span {
                height: 100%;
                display: flex;
                align-items: center;
              }
              // 选择主题
              .theme_color {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                border: 4px solid #fff;
                box-sizing: content-box;
                min-width: 0 !important;
              }
              // 选中的主题
              .theme_color-active {
                border-color: #f3f1f1;
                box-shadow: 0 0 11px 0 #d7d7d7;
                box-sizing: content-box;
              }
              // 选择字号，行距，页边距
              .font_size,
              .line_spacing,
              .page_margin {
                // width: 52px;
                color: $color-light-gray;
              }
              // 选中的字号，行距，页边距
              .font_size-active,
              .line_spacing-active,
              .page_margin-active {
                color: $color-theme;
                font-size: $font-size-medium-x;
              }
              // 排版
              .head_format {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 104px;
                height: 32px;
                margin-right: 14px;
                color: $color-light-gray;
                background-color: #f9f9f9;
                border-radius: 2px;
                .iconfont {
                  font-weight: bold;
                }
              }
              // 选中的排版
              .head_format-active {
                color: $color-light;
                background-color: $color-theme;
              }
              // 字体
              .font {
                display: flex;
                justify-content: center;
                align-items: center;
                min-width: 84px;
                height: 32px;
                margin-right: 14px;
                border-radius: 2px;
                color: $color-light-gray;
                background-color: #f9f9f9;
                padding: 0 10px;
              }
              // 选中的字体
              .font-active {
                color: $color-light;
                background-color: $color-theme;
              }
              // 排版的某一项
            }
          }
        }
      }
    }
  }
  .horizontal-scroll-list-wrap {
    /deep/ .cube-scroll-content {
      display: inline-block;
    }
    .list-wrapper {
      white-space: nowrap;
    }
    .list-item {
      display: inline-block;
      min-width: 52px;
    }
  }
</style>
